/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsTeamRecordItemDtoSchema } from "./teamRecordItemDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsTeamRecordsDtoSchema = z.object({
  get shortestGame() {
    return goodLuckCoreDTOsTeamRecordItemDtoSchema.optional();
  },
  get longestGame() {
    return goodLuckCoreDTOsTeamRecordItemDtoSchema.optional();
  },
  get biggestGoldLead() {
    return goodLuckCoreDTOsTeamRecordItemDtoSchema.optional();
  },
  get biggestGoldDeficit() {
    return goodLuckCoreDTOsTeamRecordItemDtoSchema.optional();
  },
  get mostDeathsInMatch() {
    return goodLuckCoreDTOsTeamRecordItemDtoSchema.optional();
  },
  totalPentakills: z.optional(z.int()),
});
